module.exports = __webpack_public_path__ + "img/logo.df2c0af3.png";